import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as Cloud } from "../../../Assets/img/Kyc/svg/Cloud.svg";
import VerifyDlSkeleton from "../../LoadingSkeleton/VerifyDlSkeleton";
import VerifyAadharSkeleton2 from "../../LoadingSkeleton/VerifyAadharSkeleton2";
import { Document, Page, pdfjs } from 'react-pdf';
import { Button, CircularProgress, Grid, IconButton, InputAdornment, Modal, TextField } from "@mui/material";
import Flag from "../../../Assets/img/Kyc/Flag1.jpg"
import Lion from "../../../Assets/img/Kyc/Lion.png"
import digi from "../../../Assets/img/Kyc/digi2.jpg";
import { useQuantityContext } from "../../QuantityContext";
import { FreehandCropper } from "../../Utilities/Croppers";
import axios from "axios";
import DigilockerButton from "./DigilockerButton";
import { useSelector } from "react-redux";
import { ReactComponent as EditIcon } from "../../../Assets/img/icons/edit-icon-figma.svg";
import { useDispatch } from "react-redux";
import { getKycOcrApiReducer, patchKycDLOcrApiReducer, postKycOcrApiReducer } from "../../../Redux/Reducers/KycReducer";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { ReactComponent as VerifiedTick } from "../../../Assets/img/icons/verified-tick.svg";
import { patchOnboardingReducer } from "../../../Redux/Reducers/OnboardingReducer";


pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const Verifydrivinglicense = () => {
  const [isDragging, setIsDragging] = useState(false);
  const [previewData, setPreviewData] = useState({ front: null, back: null });
  const [isVerified, setIsVerified] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [apiResponse, setApiResponse] = useState({ front: null, back: null });
  const [selectedBgImage, setSelectedBgImage] = useState(null);
  const [selectedBgFile, setSelectedBgFile] = useState(null);
  const [openRectCropper, setOpenRectCropper] = useState(false);
  const [currentSide, setCurrentSide] = useState("");
  const [ocrResponse, setOcrResponse] = useState(null);
  const { openSnackbar, handleSuccess, handleFailure, handleInfo } = useQuantityContext();
  const [userData, setUserData] = useState({})
  const [finalVerifieddata, setFinalVerifieddata] = useState({});

  const GetData = useSelector((state) => state?.Kyc?.verifiedGetData?.data?.dlData);
  const AadhaarGetData = useSelector((state) => state?.Kyc?.verifiedGetData?.data?.aadharData);
  const PanGetData = useSelector((state) => state?.Kyc?.verifiedGetData?.data?.panData);
  const digilockerCode = useSelector((state) => state?.Kyc?.digilockerDataCode);
  const [verifyStatus, setVerifiyStatus] = useState({
    aadhaar: false,
    pan: false,
    dl: false,
  });

  // console.log("GetData GetData ", GetData);

  useEffect(() => {
    const getUrl = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/digilocker/url`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("objectId")}`,
              // "ngrok-skip-browser-warning": "69420"
            },
          }
        );
        const data = response;
        // console.log("Locker data digi", response);

        if (response?.data?.statusCode === 1000) {
          // setKycCompleted(true);
          // setDisable(true);

          setIsLoading(false);

          // onKycComplete(response?.data?.data?.verified[doc]);
          setUserData(response?.data?.data?.verified["dl"]);
          return;
        } else if (response?.data?.statusCode === 200) {
          setIsLoading(false);
          // onKycComplete(response?.data?.data?.verified[doc]);
          setUserData(response?.data?.data?.verified["dl"]);
          // setUrl(response?.data?.data?.url);
          // setVerified(response?.data?.data?.verified[doc] !== null);
        }
      } catch (error) {
        openSnackbar("Error in Digilocker URL", "error");
      }
    };

    if ((GetData !== "Not verified Yet" || GetData !== null || GetData !== undefined)) {

      getUrl();
    }
  }, [GetData])


  useEffect(() => {
    const isVerified = (value) =>
      value !== "Not verified Yet" && value !== undefined && value !== null;

    setVerifiyStatus({
      aadhaar: isVerified(AadhaarGetData),
      pan: isVerified(PanGetData),
      dl: isVerified(GetData),
    });
  }, [GetData, PanGetData, AadhaarGetData]);

  // console.log("verifyStatus:", verifyStatus);

  const [digilocker, setDigilocker] = useState({
    digilockerid: '',
    reference_key: ''
  });

  // console.log("digilocker", digilocker);
  const [formData, setFormData] = useState({
    name: '',
    dob: '',
    fatherName: '',
    dl: '',
    dateofissue: '',
    dateofexpiry: '',
    address: '',
    issuedAt: '',
    // city: '',
    // district: '',
    // state: '',
    // postalCode: '',
  });

  const handleKycCompletion = (data) => {
    // console.log("Data from Digilocker:", data);

    setUserData(data);
    setIsVerified(true);
  };


  const dispatch = useDispatch();
  const [close, setClose] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };
  useEffect(() => {
    if (apiResponse.front && apiResponse.back) {
      triggerOcr(apiResponse);
    }
  }, [apiResponse]);

  // fetch image and display apiResponse if available else display skeleton
  const fetchImage = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/ocr/images`, {
        headers: {
          "x-api-key": process.env.REACT_APP_API_KEY,
          Authorization: `Bearer ${localStorage.getItem('objectId')}`,
          // "ngrok-skip-browser-warning": "69420"
        },
      });
      const front = response.data.data.filter((img) => img.document_type === "DL_Front")[0].blob_url;
      const back = response.data.data.filter((img) => img.document_type === "DL_Back")[0].blob_url;
      triggerOcr({ front, back });
      setPreviewData({ front, back });
      setIsUploaded(true);
      setOcrResponse({ ...ocrResponse, statusCode: 200 });
      setIsVerified(true);
    } catch (error) {
      console.error("Error fetching Aadhaar details:", error.message);
    }
  };

  useEffect(() => {
    fetchImage();
  }, []);


  const handleupdate = async () => {
    try {
      // console.log("FOrmData", formData);
      const dateStr = formData?.dob;
      const year = dateStr.split("-")[2];
      // console.log(year);

      const data = {
        "name": formData?.name,
        "father_name": formData?.fatherName,
        "dob": formData?.dob,
        "yob": year,
        "co": formData?.fatherName,
        "doi": formData?.dateofissue,
        "expiry_date": formData?.dateofexpiry,
        "address": formData?.address,
        "issued_at": formData?.issuedAt,
        // "state": formData?.state,
        // "postal_code": formData?.postalCode,
        // "street": formData?.street
      };


      const response = await dispatch(patchKycDLOcrApiReducer(data));
      // console.log("REsponse Data", response);
      if (response?.payload?.statusCode === 201) {
        setClose(false);
        const data = {
          "aadharVerified": verifyStatus?.aadhaar,
          "panVerified": verifyStatus?.pan,
          "dlVerified": true,
          "digilockerid": userData?.dl_number ? digilockerCode?.digilockerid : digilocker?.digilockerid,
          "reference_key": userData?.dl_number ? digilockerCode?.reference_key : digilocker?.reference_key,
        }
        const Postresponse = await dispatch(postKycOcrApiReducer(data));
        // console.log("postKycOcrApiReducer postKycOcrApiReducer", Postresponse);
        const kycresponse = await dispatch(getKycOcrApiReducer());
        if (Postresponse?.payload?.message?.message === "DigilockerID & ReferrenceKey is necessary for the verification") {
          handleInfo("DigiLocker verification is required to proceed.")
        }

        // console.log("getKycOcrApiReducergetKycOcrApiReducer", kycresponse);

        if (kycresponse?.payload?.statusCode === 200) {
          setFinalVerifieddata(kycresponse?.payload?.data?.dlData);

          const dlData = kycresponse?.payload?.data?.dlData;
          const fullName = dlData?.name || '';
          const nameParts = fullName.trim().split(' ');

          const payload = {
            first_name: nameParts.slice(0, -1).join(' '), // All except the last word
            last_name: nameParts.slice(-1)[0] || '',
            dob: dlData?.dob || null,
            gender: dlData?.gender === "F" ? "female" : "male" || null,
            address: `${dlData?.postalCode || ''} ${dlData?.locality || ''} ${dlData?.vtc || ''} ${dlData?.street || ''} ${dlData?.city || ''} ${dlData?.district || ''} ${dlData?.state || ''}`.trim()
          };
          // console.log("Payload", payload);

          const patchResponse = await dispatch(patchOnboardingReducer(payload));
          // console.log("patchResponse", patchResponse);
        }
      }
    } catch (error) {
      console.log("API ERROR", error);
    }
  };

  useEffect(() => {
    if (GetData !== "Not verified Yet") {
      setFormData({
        name: GetData?.name || '',
        dob: GetData?.dob || '',
        fatherName: GetData?.co || '',
        // aadhaar: GetData?.aadhaar_number || '',
        dateofissue: GetData?.doi || '',
        dateofexpiry: GetData?.expiry_date || '',
        address: GetData?.present_address || '',
        issuedAt: GetData?.issued_at || '',
        // city: GetData?.city || '',
        // district: GetData?.district || '',
        // state: GetData?.state || '',
        // postalCode: GetData?.postal_code || '',
      });
    } else {
      setFormData({
        name: ocrResponse?.name || '',
        dob: ocrResponse?.dob || '',
        fatherName: ocrResponse?.father_name || '',
        dl: ocrResponse?.dl_number || '',
        dateofissue: ocrResponse?.doi || '',
        dateofexpiry: ocrResponse?.expiry_date || '',
        address: ocrResponse?.address || '',
        issuedAt: ocrResponse?.issued_at || '',
        // city: ocrResponse?.city || '',
        // district: ocrResponse?.district || '',
        // state: ocrResponse?.state || '',
        // postalCode: ocrResponse?.postal_code || '',
      });
    }
  }, [ocrResponse]);

  useEffect(() => {
    const navurl = new URL(window.location.href);
    const code = navurl.searchParams.get("code");
    const state = navurl.searchParams.get("state");
    if (code && state) {
      setIsUploaded(true);
      setIsLoading(false);
      setOcrResponse({ ...ocrResponse, statusCode: 200 });
      setIsVerified(true);
    }
  }, [])

  const handleBlobUpload = async (base64Data, side) => {

    // console.log("base64Database64Data", base64Data);
    try {
      // const byteString = atob(base64Data.split(",")[1]);
      // const mimeString = base64Data.split(",")[0].split(":")[1].split(";")[0];
      // const arrayBuffer = new ArrayBuffer(byteString.length);
      // const uintArray = new Uint8Array(arrayBuffer);

      // for (let i = 0; i < byteString.length; i++) {
      //   uintArray[i] = byteString.charCodeAt(i);
      // }

      // const blob = new Blob([arrayBuffer], { type: mimeString });
      // console.log("Blob API", blob);
      // const formData = new FormData();
      // formData.append("file", blob, `${side}.jpeg`);

      // const response = await axios.post(
      //     `${process.env.REACT_APP_BACKEND_URL}/uploadpublicblob/generate-sas-url`,
      //     formData,
      //     { headers: { "Content-Type": "multipart/form-data" } }
      // );

      // const sasUrl = response.data.url;

      setApiResponse((prev) => {
        const updatedResponse = { ...prev, [side]: base64Data };

        // Check if both "front" and "back" URLs are available
        if (updatedResponse.front && updatedResponse.back) {
          // triggerOcr(updatedResponse); // Call the OCR API
        }

        return updatedResponse;
      });
    } catch (error) {
      console.error("Error uploading file:", error.message);
      handleFailure(error.message);
      // alert("Error uploading file. Please check the console for details.");
    }
  };

  // console.log("apiResponse", apiResponse);
  const triggerOcr = async (apiResponse) => {
    try {


      const viewerToken = localStorage.getItem('objectId')?.trim(); // Retrieve token from localStorage
      const apiKey = process.env.REACT_APP_API_KEY; // Get API key from environment variable

      const headers = {
        'x-api-key': apiKey,
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${viewerToken}`,
        // "ngrok-skip-browser-warning": "69420" // Add the token as Bearer
      };

      // const payload = {
      //   front: apiResponse.front,
      //   back: apiResponse.back,
      // };


      // console.log("OCR Payload:", apiResponse);
      const formData = new FormData();

      if (apiResponse.front) {
        try {
          const response = await fetch(apiResponse.front);  // Fetch blob
          const blob = await response.blob();             // Convert to blob
          // const file = new File([blob], attachment.name, { type: attachment.type }); // Create File object

          // Append as binary file
          formData.append("front_side", blob)
        } catch (error) {
          console.error("Error converting blob to file:", error);
        }
      }

      if (apiResponse.back) {
        try {
          const response = await fetch(apiResponse.back);  // Fetch blob
          const blob = await response.blob();             // Convert to blob
          // const file = new File([blob], attachment.name, { type: attachment.type }); // Create File object

          formData.append("back_side", blob);  // Append as binary file

        } catch (error) {
          console.error("Error converting blob to file:", error);
        }
      }

      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/ocr/dl`, formData, { headers });
      // console.log("OCR Response:", response);

      // Store the response in state
      setOcrResponse(response?.data?.data);
      setIsUploaded(true);
      setIsLoading(false);
      handleSuccess("Upload successful!")
    } catch (error) {
      console.error("Error during OCR API call:", error.response?.data || error.message);
      handleFailure(error.response?.data?.message);
      // alert(error.response?.data?.message || "Error processing Driving License details.");
    }
  };


  const handleDragLeave = () => setIsDragging(false);

  const handleFileDrop = (e, side) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    handleFileChange(file, side);
  };

  const handleFileChange = (file, side) => {
    if (!file) return;
    // console.log("Uploaded File only", file);
    if (file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setSelectedBgImage(event.target.result);
        setSelectedBgFile(file);
        setCurrentSide(side);
        setOpenRectCropper(true);
      };
      reader.readAsDataURL(file);
    } else if (file.type === "application/pdf") {
      const reader = new FileReader();
      reader.onloadend = () => renderPdfToImage(reader.result, side);
      reader.readAsArrayBuffer(file);
    } else {
      console.error("Unsupported file type");
    }
  };

  const resizeImage = (imageFile, width) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const scaleFactor = width / img.width;
        canvas.width = width;
        canvas.height = img.height * scaleFactor;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL("image/jpeg"));
      };
      img.src = URL.createObjectURL(imageFile);
    });
  }

  const handleSaveBgImage = async (croppedFile, side) => {
    // const resizedImageBase64 = await resizeImage(croppedFile, 512);
    const file = URL.createObjectURL(croppedFile)
    setPreviewData((prev) => ({ ...prev, [side]: file }));

    // console.log("handleSaveBgImagehandleSaveBgImage", resizedImageBase64);
    handleRectCropperClose();
  }


  const renderPdfToImage = (pdfData, side) => {
    pdfjs.getDocument({ data: pdfData }).promise.then((pdf) => {
      pdf.getPage(1).then((page) => {
        const viewport = page.getViewport({ scale: 1 });
        const canvas = document.createElement("canvas");
        const canvasContext = canvas.getContext("2d");
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        page.render({ canvasContext, viewport }).promise.then(() => {
          const resizedImageBase64 = resizeCanvasToWidth(canvas, 512);  // Resize image to 512px width
          setSelectedBgImage(resizedImageBase64);  // Set the image for cropping
          setSelectedBgFile(pdfData);  // Store the PDF data for potential use
          setCurrentSide(side);  // Set the current side for saving (front or back)
          setOpenRectCropper(true);  // Open the cropper dialog
        });
      });
    });
  };

  // console.log("Image front", previewData.front, "Image back", previewData.back);
  const handleUpload = async () => {
    if (!previewData.front || !previewData.back) {

      handleFailure("Both front and back images must be uploaded before proceeding.")
      return;
    }

    setIsLoading(true);

    try {
      // Upload both images
      await handleBlobUpload(previewData.front, "front");
      await handleBlobUpload(previewData.back, "back");

    } catch (error) {
      setIsLoading(false);
      console.error("Error during upload:", error);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const resizeCanvasToWidth = (canvas, targetWidth) => {
    const targetHeight = (targetWidth / canvas.width) * canvas.height;
    const resizedCanvas = document.createElement("canvas");
    const resizedContext = resizedCanvas.getContext("2d");

    resizedCanvas.width = targetWidth;
    resizedCanvas.height = targetHeight;

    resizedContext.drawImage(canvas, 0, 0, targetWidth, targetHeight);

    return resizedCanvas.toDataURL("image/jpeg"); // Return the resized image as base64
  };

  const handleRectCropperClose = () => {
    setOpenRectCropper(false);
    setSelectedBgFile(null);
    setSelectedBgImage(null);
  };




  const handleVerify = () => setIsVerified(true);

  const ocrFields = [
    { label: "Chip No", value: ocrResponse?.chip_no || "NA" },
    { label: "Name", value: ocrResponse?.name || "NA" },
    { label: "Father's Name", value: ocrResponse?.father_name || "NA" },
    { label: "Date of Birth", value: ocrResponse?.dob || "NA" },
    { label: "Date of Issue", value: ocrResponse?.doi || "NA" },
    { label: "Address", value: ocrResponse?.address || "NA" },
    { label: "State", value: ocrResponse?.state || "NA" },
    { label: "Blood Group", value: ocrResponse?.blood_group || "NA" },
    { label: "Email", value: ocrResponse?.email || "NA" },
    { label: "Phone", value: ocrResponse?.phone || "NA" },
    { label: "Expiry Date", value: ocrResponse?.expiry_date || "NA" },
    { label: "DL Number", value: ocrResponse?.dl_number || "NA" },
    { label: "Issued At", value: ocrResponse?.issued_at || "NA" },
    { label: "Current Address", value: ocrResponse?.current_address || "NA" },
    { label: "Present Address", value: ocrResponse?.present_address || "NA" },
    { label: "Previous Number", value: ocrResponse?.prev_number || "NA" },
    { label: "Status", value: ocrResponse?.status || "NA" },
    { label: "SWD", value: ocrResponse?.swd || "NA" },
    { label: "SWD Indicator", value: ocrResponse?.swd_indicator || "NA" },
  ];


  const verifiedFields = [
    { label: "Chip No", value: ocrResponse?.chip_no || "NA" },
    { label: "Name", value: ocrResponse?.name || "NA" },
    { label: "Father's Name", value: ocrResponse?.father_name || "NA" },
    { label: "Date of Birth", value: ocrResponse?.dob || "NA" },
    { label: "Date of Issue", value: ocrResponse?.doi || "NA" },
    { label: "Address", value: ocrResponse?.address || "NA" },
    { label: "State", value: ocrResponse?.state || "NA" },
    { label: "Blood Group", value: ocrResponse?.blood_group || "NA" },
    { label: "Email", value: ocrResponse?.email || "NA" },
    { label: "Phone", value: ocrResponse?.phone || "NA" },
    { label: "Expiry Date", value: ocrResponse?.expiry_date || "NA" },
    { label: "DL Number", value: ocrResponse?.dl_number || "NA" },
    { label: "Issued At", value: ocrResponse?.issued_at || "NA" },
    { label: "Current Address", value: ocrResponse?.current_address || "NA" },
    { label: "Present Address", value: ocrResponse?.present_address || "NA" },
    { label: "Previous Number", value: ocrResponse?.prev_number || "NA" },
    { label: "Status", value: ocrResponse?.status || "NA" },
    { label: "SWD", value: ocrResponse?.swd || "NA" },
    { label: "SWD Indicator", value: ocrResponse?.swd_indicator || "NA" },
  ];


  const Digilockerdata = {
    name: userData?.name,
    dob: userData?.dob,
    fatherName: userData?.co,
    dl: userData?.dl_number,
    dateofissue: userData?.doi,
    dateofexpiry: userData?.expiry_date,
    address: userData?.present_address,
    issuedAt: userData?.issued_at,
    // district: userData?.district,
    // State: userData?.state,
    // postalCode: userData?.postal_code
  };

  // console.log("ocrFieldsocrFields", ocrResponse, "userDatauserData", userData, "digilocker", digilocker);
  return (
    <>
      <div className="Allcards_full_container p-3">
        <div className=" rounded-2 bg-white p-2">
          <div className=" d-flex flex-column align-items-center justify-content-center m-4">
            <h2 className="m-0">Verify Your Driving License Identity</h2>
            <p className="paragraph m-0">Upload Your Driving License for Secure Verification.</p>

            <div className="d-flex flex-row justify-content-evenly mt-3">
              <div className="imagePreviewContainer">
                {!previewData.front && !previewData.back ? (
                  <VerifyDlSkeleton />
                ) : (
                  <>
                    {previewData.front && <img src={previewData.front} alt="Front Preview" style={{ maxWidth: "300px", marginBottom: "10px", boxShadow: "rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px", border: "1px dashed gray", padding: "3px" }} />}
                    {previewData.back && <img src={previewData.back} alt="Back Preview" style={{ maxWidth: "300px", marginBottom: "10px", boxShadow: "rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px", border: "1px dashed gray", padding: "3px" }} />}
                  </>
                )}
              </div>

              <div className="uploadContainer" >
                {/* {(GetData === "Not verified Yet" || GetData === null) && */}
                {(GetData === "Not verified Yet" || GetData === null || GetData === undefined) &&
                  <div className="uploadContainer-card">
                    <div
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onDrop={(e) => handleFileDrop(e, "front")}
                      className="uploadZone">
                      <input type="file" accept="image/*, application/pdf" style={{ display: "none" }} onChange={(e) => handleFileChange(e.target.files[0], "front")} id="file-input-front" />
                      <label htmlFor="file-input-front" className="uploadLabel">
                        <Cloud width={80} />
                        <span className="m-0 p-0">
                          {isDragging ? "Drop front file here" : "Drag front card here or"}
                          <span className="text-primary"> Upload File</span>
                        </span>
                        <p>1MB max file size</p>
                      </label>
                    </div>

                    <div
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onDrop={(e) => handleFileDrop(e, "back")}
                      className="uploadZone"
                    >
                      <input type="file" accept="image/*, application/pdf" style={{ display: "none" }} onChange={(e) => handleFileChange(e.target.files[0], "back")} id="file-input-back" />
                      <label htmlFor="file-input-back" className="uploadLabel">
                        <Cloud width={80} />
                        <span className="m-0 p-0">
                          {isDragging ? "Drop back file here" : "Drag back card here or"}
                          <span className="text-primary"> Upload File</span>
                        </span>
                        <p>1MB max file size</p>
                      </label>
                    </div>
                  </div>
                }



                <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                  {/* {(GetData === "Not verified Yet" || GetData === null) && ( */}
                  {(GetData === "Not verified Yet" || GetData === null || GetData === undefined) && (
                    isLoading ? (
                      <CircularProgress size={40} />
                    ) : (
                      <Button variant="contained" className="btncolor" onClick={handleUpload}>Upload</Button>
                    ))}



                  {(ocrResponse && (GetData === "Not verified Yet" || GetData === null || GetData === undefined)) ? (
                    <DigilockerButton doc={"dl"} onKycComplete={handleKycCompletion} setDigilocker={setDigilocker} />
                  ) : ""}

                  {(GetData !== "Not verified Yet" && GetData !== null && GetData !== undefined) && <h3 className="fw-semibold">KYC Verification Completed</h3>}
                </div>


                <div style={{ display: "flex", justifyContent: "space-evenly", gap: "5px", padding: "15px", borderRadius: "8px" }}>
                  <div style={{ border: "1px solid gray", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    {(GetData !== "Not verified Yet" && GetData !== null && GetData !== undefined) ? (
                      <div style={{ width: "100%", padding: "10px" }}>
                        <div className="d-flex flex-row justify-content-between align-items-center">

                          <h5 className="fw-semibold">Verified Data</h5>
                          <div className="flex-center mb-1">
                            {/* <IconButton >
                              <VerifiedTick />
                            </IconButton> */}
                            <VerifiedTick className={isVerified ? "green-verified-tick" : ""} />
                          </div>
                        </div>
                        <table className="mytable">
                          <tr>
                            <th className="mytable">Field</th>
                            <th className="mytable">Data</th>
                          </tr>
                          {verifiedFields.map((field, index) => (
                            <tr key={index}>
                              <td className="mytable"> {field.label}</td>
                              <td className="mytable" style={{ borderWidth: "1" }}>{field.value || "NA"}</td>
                            </tr>
                          ))}
                        </table>

                      </div>
                    ) : (!ocrResponse || ocrFields.every(field => !field.value || field.value === "NA")) ? (
                      ""
                    ) : (
                      <div style={{ width: "100%", padding: "10px" }}>
                        <div className="d-flex flex-row justify-content-between align-items-center">

                          <h5 className="fw-semibold">Data from OCR</h5>
                          <div className="flex-center mb-1" onClick={() => setClose(true)}>
                            <IconButton>
                              <EditIcon
                              />
                            </IconButton>
                            <div
                            >
                              Verify
                            </div>
                          </div>
                        </div>
                        <table className="mytable">
                          <tr>
                            <th className="mytable">Field</th>
                            <th className="mytable">Data</th>
                          </tr>
                          {ocrFields.map((field, index) => (
                            <tr key={index}>
                              <td className="mytable"> {field.label}</td>
                              <td className="mytable" style={{ borderWidth: "1" }}>{field.value || "NA"}</td>
                            </tr>
                          ))}
                        </table>

                      </div>)}
                  </div>

                  <div style={{ textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    {isVerified ? (
                      <div style={{ width: "100%", padding: "10px", border: "1px solid gray", }}>
                        <h5 className="fw-semibold">Data From Digilocker</h5>
                        <table className="mytable">
                          <tr>
                            <th className="mytable">Field</th>
                            <th className="mytable">Data</th>
                          </tr>
                          {userData && Object.keys(userData).map((field, index) => (
                            field !== 'photo' && (
                              <tr key={index}>
                                <td className="mytable"> {field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, " ")}</td>
                                <td className="mytable" style={{ borderWidth: "1" }}>{userData[field] || "NA"}</td>
                              </tr>
                            )
                          ))}
                        </table>
                      </div>
                    ) : ""}
                  </div>
                </div>


              </div>

              <div className="imagePreviewContainer2">
                {isVerified && previewData.front && previewData.back ? (
                  <div style={{
                    border: "2px solid gray",
                    borderRadius: "15px",
                    padding: "10px",
                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                    maxWidth: "100%",
                    margin: "auto"
                  }}>

                    <div style={{
                      display: "flex",
                      justifyContent: "space-around",
                      alignItems: "center", // This centers items vertically
                      flexWrap: "wrap",
                      rowGap: "10px",
                    }}>
                      <img style={{ width: "15%", minWidth: "80px", objectFit: "contain" }} src={Lion} alt="logo" />
                      <h6>Driving License</h6>
                    </div>

                    <hr />

                    <div style={{
                      display: "flex",
                      padding: "5px",
                      flexDirection: "row",
                      gap: "20px",
                      alignItems: "center",
                      marginTop: "15px",
                      flexWrap: "nowrap",
                      width: "60%",
                      maxWidth: "600px",

                    }}>
                      <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start" }}>
                        <div style={{ fontSize: "6px", padding: "10px", minWidth: "150px" }}>
                          <h6>Name</h6>
                          <h6>License No</h6>
                          <h6>Date of issue</h6>
                          <h6>DOB</h6>
                          <h6>S/W/D</h6>
                          <h6>Blood Group</h6>
                          <h6>Date of Expiry</h6>
                          <h6>Present Address</h6>
                          <h6 style={{ marginTop: "68px" }}>Present Address</h6>
                        </div>
                        <div
                          style={{
                            textAlign: "left",
                            flex: "1",
                            display: "flex",
                            flexDirection: "column",
                            minWidth: "260px",
                            padding: "10px",
                            fontSize: "6px"
                          }}
                        >
                          <h6>: {userData?.name}</h6>
                          <h6>: {userData?.dl_number}</h6>
                          <h6>: {userData?.doi}</h6>
                          <h6>: {userData?.dob}</h6>
                          <h6>: {userData?.swd || "N/A"}</h6>
                          <h6>: {userData?.bg || "Unknown"}</h6>
                          <h6>: {userData?.expiry_date}</h6>
                          <h6>: {userData?.current_address}</h6>
                          <h6>: {userData?.current_address}</h6>
                        </div>
                      </div>

                    </div>


                    <hr />



                    <div style={{
                      textAlign: "left",
                      padding: "20px",
                      display: "flex",
                      justifyContent: "space-evenly",
                      flexWrap: "wrap",
                      rowGap: "15px"
                    }}>
                      {/* <img
                        style={{
                          width: "30%",
                          minWidth: "100px",
                          height: "auto",
                          objectFit: "contain"
                        }}
                        src={"http://www.pngmart.com/files/10/Qr-Code-Transparent-PNG.png"}
                        alt="logo"
                      /> */}

                      {/* <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center"
                        }}
                      > */}
                      <img
                        style={{
                          width: "40%",
                          minWidth: "100px",
                          height: "auto",
                          objectFit: "contain"
                        }}
                        src={digi}
                        alt="digilocker logo"
                      />
                      {/* </div> */}
                      <img
                        style={{
                          width: "30%",
                          minWidth: "100px",
                          height: "auto",
                          objectFit: "contain"
                        }}
                        src={userData?.photo ? `data:image/png;base64,${userData?.photo}` : "https://icon-library.com/images/man-png-icon/man-png-icon-14.jpg"}
                        alt="user profile"
                      />

                    </div>

                  </div>

                ) : (
                  <VerifyAadharSkeleton2 />
                )}
                <FreehandCropper open={openRectCropper} onClose={handleRectCropperClose} onSave={(croppedFile) => handleSaveBgImage(croppedFile, currentSide)} file={selectedBgFile} selectedImage={selectedBgImage} />
              </div>

              <Modal open={close}>

                <div className="rounded p-4 m-4" style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)', position: 'absolute', background: 'white', padding: '20px', width: "800px", maxHeight: "460px", overflowY: "auto", scrollbarWidth: "thin" }}>
                  <IconButton
                    className="modal-close-button"
                    onClick={() => setClose(false)}>
                    <CloseRoundedIcon />
                  </IconButton>
                  <h5 className="fw-semibold">Verify your Driving License details</h5>
                  <Grid container spacing={2}>

                    <Grid item xs={6}>

                      {(() => {
                        const isVerified = Digilockerdata?.name && formData.name === Digilockerdata?.name;
                        const showHelper = Digilockerdata?.name && formData.name !== Digilockerdata?.name;
                        return (
                          <TextField
                            name="name"
                            variant="outlined"
                            label="Name"

                            value={formData.name}
                            onChange={handleChange}
                            disabled={isVerified}
                            required
                            fullWidth
                            helperText={
                              showHelper ? `Please Fill this:${Digilockerdata?.name}`
                                : ''
                            }
                            FormHelperTextProps={{ style: { fontStyle: 'italic', color: 'red' } }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <VerifiedTick className={isVerified ? "green-verified-tick" : ""} />
                                </InputAdornment>
                              ),
                            }}
                          />
                        )
                      })()}

                    </Grid>
                    {(Digilockerdata.dob !== "" && Digilockerdata.dob !== null && Digilockerdata.dob !== undefined) && <Grid item xs={6}>

                      {(() => {
                        const isVerified = Digilockerdata?.dob && formData.dob === Digilockerdata.dob;
                        const showHelper = Digilockerdata?.dob && formData.dob !== Digilockerdata.dob;
                        return (
                          <TextField
                            name="dob"
                            variant="outlined"
                            label="Date Of Birth"
                            value={formData.dob}
                            onChange={handleChange}
                            disabled={isVerified}
                            required
                            fullWidth
                            helperText={showHelper ?
                              `Please Fill this:${Digilockerdata?.dob}` : ''
                            }
                            FormHelperTextProps={{ style: { fontStyle: 'italic', color: 'red' } }}
                            InputProps={{
                              endAdornment: (isVerified ?
                                <InputAdornment position="end">
                                  <VerifiedTick className="green-verified-tick" />
                                </InputAdornment> :
                                <InputAdornment position="end">
                                  <VerifiedTick />
                                </InputAdornment>
                              ),
                            }}
                          />
                        )
                      })()}

                    </Grid >}

                    {(Digilockerdata.fatherName !== "" && Digilockerdata.fatherName !== null && Digilockerdata.fatherName !== undefined) && <Grid item xs={6}>
                      {(() => {
                        const isVerified = Digilockerdata?.fatherName && formData.fatherName === Digilockerdata.fatherName;
                        const showHelper = Digilockerdata?.fatherName && formData.fatherName !== Digilockerdata.fatherName;

                        return (
                          <TextField
                            name="fatherName"
                            fullWidth
                            variant="outlined"
                            label="Father Name"
                            disabled={isVerified}
                            value={formData.fatherName}
                            onChange={handleChange}
                            required
                            helperText={
                              showHelper
                                ? `Please Fill this: ${Digilockerdata?.fatherName}`
                                : ''
                            }
                            FormHelperTextProps={{ style: { fontStyle: 'italic', color: 'red' } }}
                            InputProps={{
                              endAdornment: (isVerified ?
                                <InputAdornment position="end">
                                  <VerifiedTick className="green-verified-tick" />
                                </InputAdornment> :
                                <InputAdornment position="end">
                                  <VerifiedTick />
                                </InputAdornment>
                              ),
                            }}
                          />
                        )
                      })()}

                    </Grid>}


                    <Grid item xs={6}>

                      <TextField
                        name="dl"
                        variant="outlined"
                        label="DL Number"
                        value={formData.dl || ocrResponse?.dl_number}
                        onChange={handleChange}
                        required
                        disabled={ocrResponse?.dl_number}
                        fullWidth
                        InputProps={
                          {
                            endAdornment: (ocrResponse?.dl_number ?
                              <InputAdornment position="end">
                                <VerifiedTick className="green-verified-tick" />
                              </InputAdornment> :
                              <InputAdornment position="end">
                                <VerifiedTick />
                              </InputAdornment>),
                          }
                        }
                      />
                    </Grid>
                    {(Digilockerdata?.dateofissue !== "" && Digilockerdata?.dateofissue !== null && Digilockerdata?.dateofissue !== undefined) && <Grid item xs={6}>

                      {(() => {
                        const isVerified = Digilockerdata?.dateofissue && formData.dateofissue === Digilockerdata?.dateofissue;
                        const showHelper = Digilockerdata?.dateofissue && formData.dateofissue !== Digilockerdata?.dateofissue;

                        return (
                          <TextField
                            name="dateofissue"
                            variant="outlined"
                            label="Date of Issue"
                            required
                            value={formData.dateofissue}
                            onChange={handleChange}
                            fullWidth
                            disabled={isVerified}
                            helperText={showHelper ? `Please Fill this: ${Digilockerdata?.dateofissue}` : ''}
                            FormHelperTextProps={{ style: { fontStyle: "italic", color: 'red' } }}
                            InputProps={{
                              endAdornment: (isVerified ?
                                <InputAdornment position="end">
                                  <VerifiedTick className="green-verified-tick" />
                                </InputAdornment> :
                                <InputAdornment position="end">
                                  <VerifiedTick />
                                </InputAdornment>
                              ),
                            }}
                          />
                        )
                      })()}

                    </Grid>
                    }



                    {(Digilockerdata?.dateofexpiry !== "" && Digilockerdata?.dateofexpiry !== null && Digilockerdata?.dateofexpiry !== undefined) && <Grid item xs={6}>
                      {(() => {
                        const isVerified = Digilockerdata?.dateofexpiry && formData.dateofexpiry === Digilockerdata?.dateofexpiry;
                        const showHelper = Digilockerdata?.dateofexpiry && formData.dateofexpiry !== Digilockerdata?.dateofexpiry;
                        return (
                          <TextField
                            name="dateofexpiry"
                            variant="outlined"
                            label="Date of Expiry"
                            value={formData.dateofexpiry}
                            onChange={handleChange}
                            required
                            disabled={isVerified}
                            fullWidth
                            helperText={showHelper ? `Please Fill this: ${Digilockerdata?.dateofexpiry}` : ""}
                            FormHelperTextProps={{ style: { fontStyle: 'italic', color: "red" } }}
                            InputProps={{
                              endAdornment: (isVerified ?
                                <InputAdornment position="end">
                                  <VerifiedTick className="green-verified-tick" />
                                </InputAdornment> :
                                <InputAdornment position="end">
                                  <VerifiedTick />
                                </InputAdornment>
                              ),
                            }}
                          />
                        )
                      })()}

                    </Grid>}


                    {(Digilockerdata?.address !== "" && Digilockerdata?.address !== null && Digilockerdata?.address !== undefined) && <Grid item xs={6}>
                      {(() => {
                        const isVerified = Digilockerdata?.address && formData.address === Digilockerdata?.address;
                        const showHelper = Digilockerdata?.address && formData.address !== Digilockerdata?.address;

                        return (
                          <TextField
                            name="address"
                            variant="outlined"
                            label="Address"
                            value={formData.address}
                            onChange={handleChange}
                            required
                            fullWidth
                            disabled={isVerified}
                            multiline
                            helperText={showHelper ?
                              `Please Fill this:${Digilockerdata?.address}` : ""
                            }
                            FormHelperTextProps={{
                              style: {
                                fontStyle: "italic",
                                color: "red",
                                whiteSpace: "pre-wrap",     // Preserves line breaks
                                wordBreak: "break-word",    // Breaks long words
                                overflowWrap: "break-word",
                                height: "55px" // Safe fallback
                              },
                            }}
                            InputProps={{
                              endAdornment: (isVerified ?
                                <InputAdornment position="end">
                                  <VerifiedTick className="green-verified-tick" />
                                </InputAdornment> :
                                <InputAdornment position="end">
                                  <VerifiedTick />
                                </InputAdornment>
                              ),
                            }}
                          />
                        )
                      })()}

                    </Grid>
                    }


                    {(Digilockerdata?.issuedAt !== "" && Digilockerdata?.issuedAt !== null && Digilockerdata?.issuedAt !== undefined) && <Grid item xs={6}>
                      {(() => {
                        const isVerified = Digilockerdata?.issuedAt && formData.issuedAt === Digilockerdata?.issuedAt;
                        const showHelper = Digilockerdata?.issuedAt && formData.issuedAt !== Digilockerdata?.issuedAt;

                        return (
                          <TextField
                            name="issuedAt"
                            variant="outlined"
                            label="Issued At"
                            required
                            value={formData.issuedAt}
                            onChange={handleChange}
                            fullWidth
                            disabled={isVerified}
                            helperText={showHelper ? `Please Fill this ${Digilockerdata?.issuedAt}` : ""}
                            FormHelperTextProps={{ style: { fontStyle: 'italic', color: "red" } }}
                            InputProps={{
                              endAdornment: (isVerified ?
                                <InputAdornment position="end">
                                  <VerifiedTick className="green-verified-tick" />
                                </InputAdornment> :
                                <InputAdornment position="end">
                                  <VerifiedTick />
                                </InputAdornment>
                              ),
                            }}
                          />
                        )
                      })()}

                    </Grid>}


                    {/* <Grid item xs={6} >
                      {(() => {
                        const isVerified = Digilockerdata?.city && formData.city === Digilockerdata?.city;
                        const showHelper = Digilockerdata?.city && formData.city !== Digilockerdata?.city;

                        return (
                          <TextField
                            name="city"
                            variant="outlined"
                            label="City"
                            required
                            disabled={isVerified}
                            value={formData.city}
                            onChange={handleChange}
                            fullWidth
                            helperText={showHelper ? `Please Fill this ${Digilockerdata?.city}` : ""}
                            FormHelperTextProps={{ style: { fontStyle: 'italic', color: "red" } }}
                            InputProps={{
                              endAdornment: (isVerified ?
                                <InputAdornment position="end">
                                  <VerifiedTick className="green-verified-tick" />
                                </InputAdornment> :
                                <InputAdornment position="end">
                                  <VerifiedTick />
                                </InputAdornment>
                              ),
                            }}
                          />
                        )
                      })()}

                    </Grid>

                   
                    <Grid item xs={6}>
                      {(() => {
                        const isVerified = Digilockerdata?.district && formData.district === Digilockerdata.district;
                        const showHelper = Digilockerdata?.district && formData.district !== Digilockerdata.district;

                        return (
                          <TextField
                            name="district"
                            variant="outlined"
                            label="District"
                            disabled={isVerified}
                            required
                            value={formData.district}
                            onChange={handleChange}
                            fullWidth

                            helperText={showHelper ? `Please Fill this ${Digilockerdata.district}` : ""}
                            FormHelperTextProps={{ style: { fontStyle: 'italic', color: "red" } }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <VerifiedTick className={isVerified ? "green-verified-tick" : ""} />
                                </InputAdornment>
                              ),
                            }}
                          />
                        );
                      })()}
                    </Grid>


                    <Grid item xs={6}>

                      {(() => {
                        const isVerified = Digilockerdata?.State && formData.state === Digilockerdata?.State;
                        const showHelper = Digilockerdata?.State && formData.state !== Digilockerdata?.State;

                        return (
                          <TextField
                            name="state"
                            variant="outlined"
                            label="State"
                            value={formData.state}
                            onChange={handleChange}
                            disabled={isVerified}
                            required
                            fullWidth
                            helperText={showHelper ? `Please Fill this ${Digilockerdata?.State}` : ""}
                            FormHelperTextProps={{ style: { fontStyle: 'italic', color: "red" } }}
                            InputProps={{
                              endAdornment: (isVerified ?
                                <InputAdornment position="end">
                                  <VerifiedTick className="green-verified-tick" />
                                </InputAdornment> :
                                <InputAdornment position="end">
                                  <VerifiedTick />
                                </InputAdornment>
                              ),
                            }}
                          />
                        )
                      })()}

                    </Grid>

                    <Grid item xs={6}>
                      {(() => {
                        const isVerified = Digilockerdata?.postalCode && formData.postalCode === Digilockerdata?.postalCode;
                        const showHelper = Digilockerdata?.postalCode && formData.postalCode !== Digilockerdata?.postalCode;

                        return (
                          <TextField
                            name="postalCode"
                            variant="outlined"
                            label="Postal Code"
                            value={formData.postalCode}
                            onChange={handleChange}
                            disabled={isVerified}
                            required
                            fullWidth
                            helperText={showHelper ? `Please Fill this ${Digilockerdata?.postalCode}` : ""}
                            FormHelperTextProps={{ style: { fontStyle: 'italic', color: "red" } }}
                            InputProps={{
                              endAdornment: (isVerified ?
                                <InputAdornment position="end">
                                  <VerifiedTick className="green-verified-tick" />
                                </InputAdornment> :
                                <InputAdornment position="end">
                                  <VerifiedTick />
                                </InputAdornment>
                              ),
                            }}
                          />
                        )
                      })()}

                    </Grid> */}

                  </Grid>
                  <div className="d-flex justify-content-end my-2">
                    <Button className="my-2" sx={{ color: "#0044c6" }} onClick={() => setClose(false)}>
                      CANCLE
                    </Button>


                    {(GetData !== "Not verified Yet" && GetData !== null && GetData !== undefined) ?
                      <Button variant="contained" className="verify-button success-green" disabled>
                        Verified
                      </Button> :
                      <Button className="my-2" sx={{
                        background: "#0044c6", color: "white",
                        '&:hover': {
                          background: "#0044c6", // same as default to prevent hover change
                        },
                      }}
                        onClick={() => handleupdate()}>
                        SAVE
                      </Button>}

                  </div>
                </div>
              </Modal>
            </div>


          </div>
        </div>
      </div>
    </>
  );
};

export default Verifydrivinglicense;